import React, { useState } from "react";
import ItemRow from "./Rows/ItemRow";
import MainRow from "./Rows/MainRow";
import SubHeaderQuote from "./SubHeader";

interface Props {
    elements: any[];
    sub_headers: any[];
    name: string;
    subTotal: number;
    onChange: (name, value) => void;
    onChangeItem: (i: number, name, value) => void;
    onChangeSubHeader: (i: number, name, value) => void;
    onChangeSubHeaderRow: (i: number, j: number, name, value) => void;
    onDelete: () => void;
    onDeleteSubHeader: (i: number) => void;
    onDeleteItem: (i: number) => void;
    onDeleteSubHeaderRow: (i: number, j: number) => void;
    onAddSubHeader: () => void;
    onAddItems: () => void;
    onAddSubHeaderItems: (i) => void;
    onDrag: (e) => void;
    onDragItem: (e, path: string) => void;
    onDragSubHeader: (e, i: number) => void;
    onDropItem: (e, path: string) => void;
    onDrop: (e) => void;
    onDropSubHeader: (e, i: number) => void;
    onSelectAssetsItem: (i, item) => void;
    onSelectAssetsSubHeaderRow: (i, j,  item) => void;
}

const HeaderQuote: React.FC<Props> = (props) => {
    const [isExpand, setIsExpand] = useState(true);
    const { sub_headers, elements, name, subTotal, onSelectAssetsItem, onSelectAssetsSubHeaderRow, onChange, onChangeItem, onChangeSubHeader, onChangeSubHeaderRow, onDelete, onDeleteSubHeader, onDeleteItem, onAddSubHeader, onAddItems, onDeleteSubHeaderRow, onAddSubHeaderItems, onDragItem, onDropItem, onDrop, onDropSubHeader, onDrag, onDragSubHeader } = props;

    const handleAddSubHeader = () => {
        onAddSubHeader();
        setIsExpand(true);
    }
    //agregar verificacion de vacio para expandir
    const handleAddItems = () => {
        onAddItems();
        setIsExpand(true);
    }

    return (
        <>
            <MainRow name={name} subTotal={subTotal} isExpand={isExpand} isVisible onExpand={() => setIsExpand((prev) => !prev)} onChange={onChange} onDelete={onDelete} onAddSubHeader={handleAddSubHeader} onAddItems={handleAddItems} onDrop={onDrop} onDrag={onDrag}/>
            {elements?.map((e, index) =>
                <ItemRow
                    isVisible={isExpand}
                    item={e} 
                    onChange={(name, value) => onChangeItem(index, name, value)} 
                    onDelete={() => onDeleteItem(index)}
                    onDrag = {(e) => onDragItem(e,`elements.${index}`)}
                    onDrop = {(e) => onDropItem(e,`elements.${index}`)}
                    onSelectAssets = {(item) => onSelectAssetsItem(index, item)}
                />
            )}
            {sub_headers?.map((e, index) =>
                <SubHeaderQuote
                    name={e.name}
                    subTotal={e.sub_total}
                    isVisible={isExpand}
                    elements={e.elements}
                    onChange={(name, value) => onChangeSubHeader(index, name, value)}
                    onChangeItem={(rowIndex, name, value) => onChangeSubHeaderRow(index, rowIndex, name, value)}
                    onDelete={() => onDeleteSubHeader(index)}
                    onDeleteItem={(rowIndex) => onDeleteSubHeaderRow(index, rowIndex)}
                    onAddItems={() => onAddSubHeaderItems(index)}
                    onDragItem = {(e, path) => onDragItem(e,`sub_headers.${index}.${path}`)}
                    onDropItem = {(e, path) => onDropItem(e,`sub_headers.${index}.${path}`)}
                    onDrop = {(e) => onDropSubHeader(e,index)}
                    onDrag = {(e) => onDragSubHeader(e,index)}
                    onSelectAssetItem = {(rowIndex, item) => onSelectAssetsSubHeaderRow(index, rowIndex, item)}
                />
            )}
        </>
    );
};

export default HeaderQuote;